import { useFeatureFlagEnabled } from "posthog-js/react";

import { BankingAccountsPage } from "./banking-accounts";
import { BankingNextPage } from "./banking-next";

const NEW_BANKING_ACCOUNTS_PAGE_FLAG = "new_onboarding_banking_account_page";

export const BankingPage = () => {
  const newAccountsPageEnabled = useFeatureFlagEnabled(NEW_BANKING_ACCOUNTS_PAGE_FLAG);
  return newAccountsPageEnabled ? <BankingAccountsPage /> : <BankingNextPage />;
};
